module.exports = __webpack_public_path__ + "assets/img/desc.1fad539d.png";